import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ProductStockUpdateLayer from "../components/ProductStockUpdateLayer";

const ProductStockUpdatePage = () => {
    return (
        <MasterLayout>
            <ProductStockUpdateLayer />
        </MasterLayout>
    );
};

export default ProductStockUpdatePage;
